(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};

  var mb=$('[data-menu]'),nav=$('[data-nav]');
  if(mb&&nav)mb.addEventListener('click',function(){var o=nav.classList.toggle('open');mb.setAttribute('aria-expanded',o)});

  /* Galerie : flèches (ordinateur + téléphone), miniatures, balayage tactile, clavier */
  $$('[data-gallery]').forEach(function(g){
    var track=$('[data-track]',g),slides=$$('.g-slide',track),thumbs=$$('.g-thumb',g),count=$('[data-count]',g),i=0;
    function mark(){thumbs.forEach(function(t,k){t.classList.toggle('on',k===i)});if(count)count.textContent=(i+1)+' / '+slides.length}
    function go(n){i=(n+slides.length)%slides.length;track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});mark()}
    track.addEventListener('scroll',function(){var k=Math.round(track.scrollLeft/track.clientWidth);if(k!==i){i=k;mark()}},{passive:true});
    $('[data-prev]',g).addEventListener('click',function(){go(i-1)});
    $('[data-next]',g).addEventListener('click',function(){go(i+1)});
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')go(i-1);if(e.key==='ArrowRight')go(i+1)});
    g.goToAlt=function(t){var k=slides.findIndex(function(s){var im=s.querySelector('img');return im&&(im.alt||'').toLowerCase().indexOf(t)>-1});if(k>-1){go(k);return true}return false};
    g.goToMedia=function(id){var k=slides.findIndex(function(s){return String(s.dataset.mediaId)===String(id)});if(k>-1)go(k)};
    mark();
  });

  /* Variantes : un clic sur une couleur affiche la photo correspondante */
  function norm(x){return String(x==null?'':x).trim().toLowerCase()}
  $$('[data-product-section]').forEach(function(sec){
    var data=$('[data-variants]',sec.parentNode)||$('[data-variants]');
    if(!data)return;
    var variants=JSON.parse(data.textContent),
        idIn=$('[data-variant-id]',sec),price=$('[data-price]',sec),btn=$('[data-add]',sec),g=$('[data-gallery]',sec);
    function selected(){return $$('fieldset[data-option-index]',sec).map(function(f){var c=$('input:checked',f),l=$('[data-opt-label]',f);if(c&&l)l.textContent=c.value;return c?norm(c.value):''})}
    function update(){
      var s=selected(),
          v=variants.find(function(x){return x.options.every(function(o,k){return norm(o)===s[k]})})
            ||variants.find(function(x){return norm(x.options[0])===s[0]});
      if(v){
        idIn.value=v.id;
        price.innerHTML=(v.onsale?'<s>'+v.compare+'</s> ':'')+v.price;
        btn.disabled=!v.available;btn.textContent=v.available?'Ajouter au panier':'Indisponible';
        if(history.replaceState)history.replaceState(null,'','?variant='+v.id);
      }else{btn.disabled=true;btn.textContent='Indisponible'}
      if(g){
        var shown=false;
        if(v&&v.media)g.goToMedia(v.media),shown=true;
        if(!shown)for(var k=0;k<s.length&&!shown;k++)if(s[k])shown=g.goToAlt(s[k]);
      }
    }
    sec.addEventListener('change',function(e){if(e.target.type==='radio')update()});
    var cur=variants.find(function(x){return String(x.id)===String(idIn.value)});
    if(cur&&cur.media&&g&&location.search.indexOf('variant=')>-1)setTimeout(function(){g.goToMedia(cur.media)},50);
  });
})();
